import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLabResultatDashboard } from 'apiServices/reducer/apiService';
import { CTGrid, StethoscopeLoading } from 'components';
import { toast } from 'react-toastify';

const LabResultsCard = ({
    userId: dashboardUserId,
    showAddButton,
    onAdd,
    onRemove,
    widgetName,
    draggable = false,
    onDragStart,
    hideHeader = false,
    selectedFamilyMember
}) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    const isProvider = userData.user_type_name === 'Provider';
    const userId = selectedFamilyMember?.user_id || dashboardUserId || (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);
    const token = useSelector((state) => state.apiService?.token);
    const [labResults, setLabResults] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log("userId:", userId);
        console.log("token:", token);
        console.log("isProvider:", isProvider);
        const fetchLabResults = async () => {
            if (!userId || !token) {
                setLoading(false);
                setLabResults([]);
                return;
            }
            setLoading(true);
            dispatch(getLabResultatDashboard({ user_id: userId, token })).then((response) => {
                let labResultData = [];
                if (response.payload && Array.isArray(response.payload)) {
                    labResultData = response.payload;
                } else if (response.payload && Array.isArray(response.payload.Table)) {
                    labResultData = response.payload.Table;
                } else if (response.payload && response.payload.data && Array.isArray(response.payload.data.Table)) {
                    labResultData = response.payload.data.Table;
                }
                if (labResultData.length > 0) {
                    const formattedData = labResultData.map(labResult => ({ 
                        name: labResult.report_name,
                        date: labResult.report_date, 
                    }));
                    setLabResults(formattedData);
                } else {
                    setLabResults([]);
                }
                setLoading(false);
            }).catch(() => setLoading(false));
        };
        fetchLabResults();
        // Only rerun if userId or token changes
    }, [userId, token, dispatch, selectedFamilyMember]);

 
    const labColumns = [
        { 
            headerName: "Report Name", 
            field: "name", 
            flex: 1,
            tooltipField: 'name',  
            headerTooltip: 'Report Name',
            wrapText: true,
            autoHeight: true,
            cellClass: 'lab-report-name-wrap',
            cellRenderer: (params) => {
                const name = params.value || "N/A";
                return (
                    <div
                        style={{
                            fontSize: '12px',
                            color: '#6b7280',
                            fontWeight: '500',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            lineHeight: '1.6',
                            width: '100%'
                        }}
                    >
                        {name}
                    </div>
                );
            }
        },
        { 
            headerName: "Report Date", 
            field: "date",
            tooltipField: 'date', 
            headerTooltip: 'Report Date',
            cellRenderer: (params) => {
                const date = params.value || "N/A";
                return (
                    <div
                        style={{
                            fontSize: '12px',
                            color: '#6b7280',
                            fontWeight: '500'
                        }}
                    >
                        {date}
                    </div>
                );
            }
        }                    
    ];
    console.log("labResults:", labResults);
    console.log("labColumns:", labColumns);

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        minWidth: 100
    };

    if (loading) {
        return (
            <StethoscopeLoading message="Loading..." />
        );
    }

    return (
        <>
            {!hideHeader ? (
                <div
                    className="cardwidget d-flex flex-column shadow-lg upcoming-widget-cardwidget allergy-card-container shadow-sm border-0 mb-5"
                    draggable={draggable}
                    onDragStart={onDragStart}
                >
                    <div className="cardwidget-header d-flex justify-content-between align-items-center px-3 py-1">
                        <h6 className="mb-0 fw-bold text-capitalize">{widgetName || 'Lab Results'}</h6>
                        {showAddButton ? (
                            <button className="btn btn-sm" onClick={onAdd} title="Add to Dashboard">+</button>
                        ) : (
                            <button className="btn btn-sm" onClick={onRemove} title="Remove from Dashboard">×</button>
                        )}
                    </div>
                    <div className="cardwidget-body px-3 py-2 flex-grow-1">
                        {labResults.length > 0 ? (
                            <CTGrid 
                                rowData={labResults} 
                                columnDefs={labColumns} 
                                defaultColDef={defaultColDef}
                                height={isProvider ? 250 : 295}
                                enableCellTextSelection={true}
                                suppressRowClickSelection={true}
                                tooltipShowDelay={0}
                            />
                        ) : (
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <p className="text-muted mb-0">No lab results available</p>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div style={{ padding: '16px 12px' }}>
                    {labResults.length > 0 ? (
                        <CTGrid 
                            rowData={labResults} 
                            columnDefs={labColumns} 
                            defaultColDef={defaultColDef}
                            height={isProvider ? 250 : 295}
                            enableCellTextSelection={true}
                            suppressRowClickSelection={true}
                                tooltipShowDelay={0}
                        />
                    ) : (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <p className="text-muted mb-0">No lab results available</p>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default LabResultsCard;
